import { render, staticRenderFns } from "./Sidecart.vue?vue&type=template&id=58a13aed&scoped=true&lang=pug"
import script from "./Sidecart.vue?vue&type=script&lang=js"
export * from "./Sidecart.vue?vue&type=script&lang=js"
import style0 from "./Sidecart.vue?vue&type=style&index=0&id=58a13aed&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a13aed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a13aed')) {
      api.createRecord('58a13aed', component.options)
    } else {
      api.reload('58a13aed', component.options)
    }
    module.hot.accept("./Sidecart.vue?vue&type=template&id=58a13aed&scoped=true&lang=pug", function () {
      api.rerender('58a13aed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/cart/Sidecart.vue"
export default component.exports